import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/service-bg.jpg";
import { Link, useLocation } from "react-router-dom";

const AI_RPA_Coe = () => {
  pageTitle("AI & RPA Center of Excellence");

  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper">
        <img src={aiAccounting} alt="AI Operations" className="img-fluid" />

        <div className="ai-overlay">
          <h2 className="rpa-af-title">RPA CENTER OF EXCELLENCE</h2>
          <p>Align People, Processes, and Technology</p>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container container">
          <div className="siw-rpa-content">
            <span className="siw-rpa-tag">
              Scale and Accelerate Your Automation Program
            </span>

            <div className="siw-rpa-text">
              <p>
                Effective automation programs are built on a solid foundation and a clearly defined operating model. An RPA Center of Excellence (CoE) provides organizations with the structure needed to scale intelligent automation enterprise-wide by standardizing skills, processes, technologies, and governance.
              </p>
            </div>

            <p className="siw-rpa-desc">
              Primarily, an RPA CoE is a way for you to scale your automation
              program. It streamlines the implementation and deployment process
              while establishing guardrails to achieve your business outcomes
              significantly faster.An RPA CoE serves as the backbone of automation scalability, enabling faster implementation and deployment while ensuring the right controls are in place to consistently deliver measurable business outcomes.
            </p>
            <p className="siw-rpa-desc">
              More than an operational capability, an RPA CoE is a long-term strategic investment. As automation continues to evolve, a strong CoE ensures the right decisions are made from the outset. It helps uncover process inefficiencies, develop internal automation expertise, and drive a disciplined, value-focused implementation strategy—maximizing return on investment and sustaining long-term success.
            </p>
          </div>

          <div className="siw-rpa-cta">
            <h3>
              <span>Contact us</span> to discuss your <br />
              RPA Center of Excellence or
            </h3>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              INSTANTLY BOOK A MEETING
            </a>
          </div>
        </div>
      </section>

      <section className="siw-approach-coe">
        <div className="siw-approach-coe-container container">
          <span className="siw-approach-coe-label">OUR APPROACH</span>

          <div className="siw-approach-coe-divider"></div>

          <div className="siw-approach-coe-content">
            <p>
              Business transformation requires more than technology alone; it depends on
  effectively integrating people and processes with RPA to build a resilient,
  enterprise-wide automation program. <span className="SiW">SiW</span>’s RPA CoE framework aligns IT and
  business priorities to accelerate automation adoption and scalability.
            </p>

            <p>
              <span className="SiW">SiW</span>’s automation specialists bring extensive experience in establishing RPA
  Centers of Excellence that drive scalability, improve operational efficiency,
  and reduce costs. We help embed the CoE within automated processes while
  building skills and enabling employee adoption. <span className="SiW">SiW</span> supports your
  organization through the following:
            </p>
<ul className="siw-approach-coe-list">
  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Identifying and selecting the right automation technology partner
  </li>

  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Developing the core skills and capacity required for automation
  </li>

  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Defining a robust governance framework and operating model
  </li>

  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Enabling training, readiness, and scalable adoption
  </li>

  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Establishing standardized tools, frameworks, and best practices
  </li>

  <li>
    <span className="siw-approach-coe-icon">
      <i className="fa-solid fa-robot"></i>
    </span>
    Driving continuous improvement and enterprise-scale automation
  </li>
</ul>

          </div>
        </div>
      </section>

      <FooterOne></FooterOne>
    </>
  );
};

export default AI_RPA_Coe;
